(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/dropRightWhile', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/dropRightWhile'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.dropRightWhile, global.convert);
    global.dropRightWhile = mod.exports;
  }
})(this, function (exports, _dropRightWhile2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.dropRightWhile = undefined;

  var _dropRightWhile3 = _interopRequireDefault(_dropRightWhile2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array excluding elements dropped from the end. Elements are dropped until <code>predicate</code> returns falsey.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example dropRightWhile({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v > 2) // => { nested: { prop: [1, 2] } }
   * @see {@link https://lodash.com/docs#dropRightWhile|lodash.dropRightWhile} for more information.
   * @since 0.3.0
   */
  var dropRightWhile = (0, _convert.convert)(_dropRightWhile3.default);
  exports.dropRightWhile = dropRightWhile;
  exports.default = dropRightWhile;
});